import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { IHealioStoreCartRequest } from "../../models/HealioBigComm/IHealioStoreCartRequest";
import * as Mustache from "mustache";
import { NumberUtil } from "../../util/NumberUtil";
import { PageContext } from "../../service/PageContext";
import { UiUtil } from "../../util/UiUtil";
import { LocalStorageUtil } from "../../healio-custom-scripts-newsarea";

export class PublicationSubscription extends Component {
    private _bindableEvents = ['keypress', 'click'];
    private readonly _bigCommerceCategoryId:
        string | undefined = undefined;
    private readonly cartIdKey = "CartId";
    private healioBigCommStorage : LocalStorageUtil | null = null;
    private readonly localDataStore = "HealioBigComm";
    private _loading: boolean = false;
    private readonly _newsSubscriptionCardTemplate:
        string | null = null;
    private readonly _newsSubscriptionListItemTemplate:
        string | null = null;
    private readonly _newsSubscriptionVariantItemTemplate:
        string | null = null;
    private _spinner: Element | null;
    private _subscriptionCardsElement: HTMLDivElement | null;
    private _subscriptionUnorderedListElement: HTMLUListElement | null;
    private _tempDivElement: JQuery<HTMLElement> = $("<div></div>");


    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        const newsSubsciptionCardTemplate = $("#NewsSubscriptionCardTemplate");
        if (newsSubsciptionCardTemplate.length) {
            this._newsSubscriptionCardTemplate = newsSubsciptionCardTemplate.html().trim();
        }

        const newsSubsciptionListItemTemplate = $("#NewsSubscriptionListItemTemplate");
        if (newsSubsciptionListItemTemplate.length) {
            this._newsSubscriptionListItemTemplate = newsSubsciptionListItemTemplate.html().trim();
        }

        const newsSubscriptionVariantItemTemplate = $("#NewsSubscriptionVariantTemplate");
        if (newsSubscriptionVariantItemTemplate.length) {
            this._newsSubscriptionVariantItemTemplate = newsSubscriptionVariantItemTemplate.html().trim();
        }

        this._subscriptionCardsElement = this._element.querySelector("div[data-mustache-rendered='subsciption-cards']");
        this._subscriptionUnorderedListElement = this._element.querySelector("ul[data-mustache-rendered='subsciption-unordered-list']");
        this._bigCommerceCategoryId = this._element.dataset.categoryId;

        this._spinner = document.querySelector(".loading-spinner");

    }

    public async init(): Promise<void> {
        this.healioBigCommStorage = new LocalStorageUtil(this.localDataStore);
        let newspaperHeadingElement = this._element.querySelector<HTMLHeadingElement>('#newspapers-tab')
        let cardHeaderDivElement = this._element.querySelector<HTMLDivElement>('.card-header')
        let slackHeadingElement = this._element.querySelector<HTMLHeadingElement>('#slack-tab')
        this._bindableEvents.forEach(evt => {

            cardHeaderDivElement?.addEventListener(evt,
                (event) => {
                    let keyboardEvent = event as KeyboardEvent;
                    if (keyboardEvent?.code?.toLocaleLowerCase() === "enter" || event.target) {
                        $('.card-header i.far').toggleClass("fa-plus fa-minus");
                    }
                },
                false
            );

            newspaperHeadingElement?.addEventListener(evt,
                (event) => {
                    let keyboardEvent = event as KeyboardEvent;
                    if (keyboardEvent?.code?.toLocaleLowerCase() === "enter" || event.target) {
                        $('.slack-tab-content').hide();
                        $('.newspapers-content').show();
                        $('#slack-tab').removeClass('active');
                        $('#newspapers-tab').addClass('active');

                        if (window.innerWidth <= 415) {
                            $('.mobile-select').show();
                        }
                    }
                }, false);

            slackHeadingElement?.addEventListener(evt,
                (event) => {
                    let keyboardEvent = event as KeyboardEvent;
                    if (keyboardEvent?.code?.toLocaleLowerCase() === "enter" || event.target) {
                        $('.newspapers-content').hide();
                        $('.mobile-select').hide();
                        $('.slack-tab-content').show();
                        $('#newspapers-tab').removeClass('active');
                        $('#slack-tab').addClass('active');
                    }
                }, false);

        });

        window.addEventListener("resize", () => {
            if (window.innerWidth > 991) {
                $('.mobile-select').hide();
                $('.slack-tab-content').hide();
                $('.newspapers-content').show();
                $('#newspapers-tab').addClass('active');
                $('#slack-tab').removeClass('active');
            } else if (window.innerWidth < 415 && $('#newspapers-tab').hasClass('active')) {
                $('.mobile-select').show();
            }
        })
        await this.loadSubsciptionProducts();
    }

    private bindToAnchorLinks(): void {
        const publicationSubscriptionComponent = this;
        $("#collapseNewsPubs .card-body ul li a").each(function () {
            var abbreviation = $(this)?.attr("href")?.replace("#", "") ?? "";
            if (abbreviation !== "") {
                $(this).on('click', function () {
                    publicationSubscriptionComponent.goToAnchorAndToggle(abbreviation);
                });
            }
        });
    }

    private bindToSubscribeButtons(): void {
        let subscribeButtons = this._element.querySelectorAll<HTMLButtonElement>('.news-card button');
        subscribeButtons.forEach(element => {
            element?.addEventListener("click", event => {
                this.subscribeClicked(event);
            })
        });
    }

    private bindToSubscriptionRadioButtons(): void {
        let radioButtonDivElements = this._element.querySelectorAll<HTMLDivElement>('.single-radio-option')
        this._bindableEvents.forEach(evt => {
            radioButtonDivElements.forEach(element => {
                element?.addEventListener(evt, (event) => {
                    let keyboardEvent = event as KeyboardEvent;
                    if (keyboardEvent?.code?.toLocaleLowerCase() === "enter" || event.target) {
                        $('.single-radio-option input').prop('checked', false);
                        $('.news-card button').addClass('inactive');
                        $(element).find('input').prop('checked', true);
                        $(element).closest('.news-card').find('button').removeClass('inactive');
                    }
                })
            })
        });
    }

    private goToAnchorAndToggle(abbreviation: string): void {
        var divTag = $("div[name='" + abbreviation + "']");
        if (divTag !== undefined && divTag.length > 0) {
            const offSet = divTag.offset()?.top;
            if (offSet) {
                $('html,body').animate({ scrollTop: offSet - 75 }, 'fast');
            }
        }
    }

    private async loadSubsciptionProducts(): Promise<void> {
        if (this._loading) {
            return;
        }
        const context = this._pageContext;
        try {
            this._loading = true;
            const service = context?.healioStoreService;
            if (!service) {
                throw new Error("HealioStoreService not found");
            }
            if (!this._bigCommerceCategoryId) {
                throw new Error("CategoryId Not Set for Component")
            }
            this.startSpinner();
            const productsPromise = service.productsByCategoryId(this._bigCommerceCategoryId)

            const productsResponse = await productsPromise;

            let products = productsResponse?.data;

            let productsFlattened = products?.map(product => {
                return {
                    Abbreviation: product.sku,
                    Title: product.name,
                    CoverImageAlt: product.name,
                    CoverImageUrl: product.images[0].url_standard,
                    Variants: product.variants.map(variant => {
                        return {
                            Abbreviation: product.sku,
                            ProductId: product.id,
                            Price: NumberUtil.formatPrice(variant.calculated_price),
                            UnformattedPrice: variant.calculated_price,
                            VariantId: variant.id,
                            VariantLabel: variant.option_values[0].label
                        }
                    }
                    )
                }


            })
            let subscriptionListItems = this.renderListItemsFromTemplate(productsFlattened);
            if (this._subscriptionUnorderedListElement) {
                this._subscriptionUnorderedListElement.innerHTML = subscriptionListItems;
            }
            let subscriptionCards = this.renderCardsFromTemplate(productsFlattened);
            if (this._subscriptionCardsElement) {
                this._subscriptionCardsElement.innerHTML = subscriptionCards;
            }

            this.bindToAnchorLinks();
            this.bindToSubscriptionRadioButtons();
            this.bindToSubscribeButtons();
        }
        catch (error) {
            console.error(error)
        }
        finally {
            this._loading = false;
            this.stopSpinner(0);
        }
    }

    private renderCardsFromTemplate(products: any): string {
        let renderedCards = "";
        // tslint:disable-next-line: no-unsafe-any
        if (this._newsSubscriptionCardTemplate) {
            for (let product of products) {
                const renderedCardTemplate = Mustache.render(this._newsSubscriptionCardTemplate, product);
                this._tempDivElement.html(renderedCardTemplate);
                for (let variant of product.Variants) {
                    if (this._newsSubscriptionVariantItemTemplate) {
                        const renderedVariantTemplate = Mustache.render(this._newsSubscriptionVariantItemTemplate, variant)
                        this._tempDivElement.find('[data-mustache-rendered="subsciption-variants"]').append(renderedVariantTemplate);
                    }
                }
                renderedCards += UiUtil.replaceDataSrcWithSrcInImageTags(this._tempDivElement.html());
            };
        }

        return renderedCards;
    }

    private renderListItemsFromTemplate(products: any): string {
        let renderedCards = "";
        // tslint:disable-next-line: no-unsafe-any
        if (this._newsSubscriptionListItemTemplate) {
            for (let product of products) {
                const renderedTemplate = Mustache.render(this._newsSubscriptionListItemTemplate, product);
                this._tempDivElement.html(renderedTemplate);
                renderedCards += this._tempDivElement.html();
            };
        }

        return renderedCards;
    }

    private stopSpinner(timeout: number): void {
        setTimeout(() => {
            if (this._spinner) {
                this._spinner.classList.remove("active");
            }
        }, timeout);
    }

    private startSpinner(): void {
        if (this._spinner) {
            this._spinner.classList.add("active");
        }
    }

    private async subscribeClicked(clickEvent: Event): Promise<void> {
        const service = this._pageContext?.healioStoreService;
        if (!service) {
            throw new Error("HealioStoreService not found");
        }
        if (!clickEvent?.target) {
            throw new Error("Unable to find Target Clicked")
        }
        const abbreviation = $(clickEvent.target).data("subcribe-button");

        const messageId = "select-message-" + abbreviation;
        $(".select-message").hide();
        var messageSelector = "#" + messageId;

        //find all selected products
        var result = "";
        $("input[name='group_" + abbreviation + "']:radio:checked").each(function () {
            var selectedValue = $(this).val();
            if(selectedValue && typeof(selectedValue) === "string") {
                result = selectedValue;
            }
        });

        if (result.length == 0) {
            $(messageSelector).show();
        } else {
            $(messageSelector).hide();
            UiUtil.toggleButtonState(clickEvent.target as HTMLButtonElement)

            const productAndVariant = result.split("|")

            const cartRequest: IHealioStoreCartRequest = {
                "cart_id" : this.healioBigCommStorage?.getItem(this.localDataStore,[this.cartIdKey]) || null,
                "line_items": [
                    {
                        "quantity": 1,
                        "product_id": productAndVariant[0],
                        "variant_id": productAndVariant[1],
                        "list_price": productAndVariant[3]
                    }
                ]
            };
            const cartRedirectResponse = await service.addProductToCart(cartRequest)
            const cartId = cartRedirectResponse?.Data.cart_id
            this.healioBigCommStorage?.insertItem(this.localDataStore,[this.cartIdKey], cartId)
            const checkoutUrl = cartRedirectResponse?.Data?.checkout_url;
            UiUtil.toggleButtonState(clickEvent.target as HTMLButtonElement)
            if (checkoutUrl) {
                window.location.href = checkoutUrl;
            }
        }
    }

}

ComponentFactory.registerComponent("PublicationSubscription",
    PublicationSubscription);
